const brand = {
  freshZone: "assets/img/Portfolio/freshzone.png",
  stringer: "assets/img/Portfolio/ic_launcher.png",
  spacecoin: "assets/img/Portfolio/spacecoinlogo.png",
  infiiot: "assets/img/Portfolio/infiiot logo square.png",
  gondoor: "assets/img/Portfolio/gondoor.png",
  warrantyNinja: "assets/img/Portfolio/WarrantyNinjaLogo.webp",
};
module.exports = brand;
